<template>
  <div class="hello flex">
    <div class="left">
      <centerleft></centerleft>
    </div>
    <div class="right">
      <div class="head1">
        账号信息
      </div>
      <div class="main1">
        <div class="one1">
          <span style="width:100px;">头像：</span><img class="headImg"
            :src="'https://yunzhixuanpro.fw366.cn/'+userInfo.avatar_img">
        </div>
        <div class="one flex">
          <div class="flex">
            <span>用户名：</span>
            <el-input style="width: 263px;" v-model="userInfo.nickname" placeholder="请输入内容"></el-input>
          </div>
          <!-- <div class="flex">
            <span>个人介绍：</span>
            <el-input style="width: 263px;"  placeholder="请输入内容"></el-input>
          </div> -->
        </div>
        <div class="one1 flex">
          <span>手机号：</span>
          <el-input style="width: 263px;" v-model="userInfo.mobile" disabled></el-input>
        </div>
        <div class="caozuo1">
          <button @click="out">退出登录</button>
        </div>
      </div>
      <div class="head1">
        学生信息
      </div>
      <div class="main1">
        <div class="one ">
          <div class="flex">
            <span>高考省份：</span>
            <div>
              <el-select :disabled=disabled v-model="userInfo.province_name" :placeholder="userInfo.province_name"
                @change="change0($event)" style="width: 200px;">
                <el-option v-for="item in options0" :key="item.value" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="userInfo.city_name" :placeholder="userInfo.city_name" @change="change($event)"
                style="width: 200px;">
                <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="userInfo.county_name" :placeholder="userInfo.county_name" @change="change1($event)"
                style="width: 200px;">
                <el-option v-for="item in options1" :key="item.name" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="one1 ">
          <span>高考年份:</span>
          <!-- <el-date-picker v-model="userInfo.year" type="year" placeholder="选择年" :format="yyyy" :value-format='yyyy'
            :default-value="defaultValue">
          </el-date-picker> -->
          <el-select v-model="userInfo.year" placeholder="请选择" @change="changeYear" style="width: 263px;">
            <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="one1" v-if="type==1">
          <span>科目:</span>
          <el-select v-model="userInfo.subject_type_1==1?'理科':'文科'" :placeholder="userInfo.subject_type_1==1?'理科':'文科'"
            @change="change3($event)" style="width: 263px;">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-select v-else v-model="userInfo.subject_type_1" @change="change3($event)" style="width: 200px;">
            <el-option v-for="item in options2" :key="item.name" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
        </div>
        <div class="one1 " v-if="type==2">
          <div class="one1 flex">
            <span>首选科目:</span>
            <div> <template>
                <el-radio-group v-model="userInfo.subject_type_1" fill="#C10B17" text-color='#C10B17'
                  @change="change3($event)">
                  <el-radio label="1" fill="#C10B17" text-color='#C10B17'>物理</el-radio>
                  <el-radio label="4" fill="#C10B17" text-color='#C10B17'>历史</el-radio>
                </el-radio-group>
              </template>
            </div>
          </div>
          <div class="one1 flex">
            <span>再选科目:</span>
            <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17'
              style="text-align: left;margin-top: 10px;" :max="2" @change="kemu_change">
              <el-checkbox v-for="item in options3" :label="item.value" :key="item.value" text-color='#C10B17'
                fill='#C10B17'>{{item.label}}</el-checkbox>
            </el-checkbox-group>

          </div>
        </div>
        <div class="one1" v-if="type==3">
          <span>选择科目</span>
          <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17'
            style="text-align: left;margin-top: 10px;" :max="3">
            <el-checkbox v-for="item in options3" :label="item.value" :key="item.value" text-color='#C10B17'
              fill='#C10B17'>{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="one1 ">
          <span>高考分数:</span>
          <el-input style="width: 263px;" v-model="userInfo.score" @input="getRank" placeholder="请输入内容"></el-input>
        </div>
        <div class="one1" v-show="userInfo.score_rank!=null">
          <span>位次:</span>
          <el-input style="width: 263px;" v-model="userInfo.score_rank" disabled placeholder=""></el-input>
        </div>
        <div class="one1 ">
          <span>学校:</span>
          <el-input style="width: 263px;" v-model="userInfo.school" placeholder="请输入内容"></el-input>
        </div>
        <div class="one1 ">
          <span>年级:</span>
          <el-select v-model="userInfo.grade" placeholder="请选择" style="width: 263px;">
            <el-option v-for="item in grade_list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="one1 ">
          <span>性别:</span>
          <!-- <el-date-picker v-model="userInfo.year" type="year" placeholder="选择年" :format="yyyy" :value-format='yyyy'
            :default-value="defaultValue">
          </el-date-picker> -->
          <el-select v-model="userInfo.gender" placeholder="请选择" @change="changeXingBie" style="width: 263px;">
            <el-option v-for="item in gender" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="caozuo">
          <button @click="save">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import centerleft from '../../components/me/centerleft.vue'
  export default {
    data() {
      return {
        radio1: '',
        radio2: '',
        radio: '',
        yearList: [{
            value: '2022',
            label: '2022'
          },
          {
            value: '2023',
            label: '2023'
          },
          {
            value: '2024',
            label: '2024'
          },
          {
            value: '2025',
            label: '2025'
          },
          {
            value: '2026',
            label: '2026'
          },
          {
            value: '2027',
            label: '2027'
          },
          {
            value: '2028',
            label: '2028'
          },
          {
            value: '2029',
            label: '2029'
          },
          {
            value: '2030',
            label: '2030'
          }
        ],
        options: [],
        options1: [],
        checkedCities: [],
        options2: [{
          label: '理科',
          value: 1
        }, {
          label: '文科',
          value: 2
        }],
        gender: [{
            value: 1,
            label: '男'
          },
          {
            value: 2,
            label: '女'
          }
        ],
        options3: [],
        grade_list: [{
          value: 1,
          label: '高三'
        }, {
          value: 2,
          label: '高二'
        }, {
          value: 3,
          label: '高一'
        }, {
          value: 4,
          label: '初三'
        }, {
          value: 5,
          label: '初二'
        }, {
          value: 6,
          label: '初一'
        }],
        options0: [],
        value: '',
        value1: '',
        value2: '',
        userInfo: [],
        disabled: false,
        type: '1',
        defaultValue: '',
        isRank: true
      }
    },
    components: {
      centerleft
    },
    created() {
      this.$http.getUserInfo().then(res => {
        this.userInfo = res.data
        if (res.data.province == null) {
          this.isRank = false
        }
        if (res.data.subject_type_1 == null) {
          this.userInfo.subject_type_1 = 1
        }
        localStorage.setItem('userInfo', JSON.stringify(res.data))
        localStorage.setItem('teacher_show', res.data.teacher_show)
        localStorage.setItem('admin_show', res.data.admin_show)
        if (this.userInfo.province_name == '') {
          this.disabled = false
        }
        this.$http.subjectTypeList({
          province_id: res.data.province,
        }).then(res => {
          this.type = res.data.type
          if (res.data.type == 2) {
            this.options3 = res.data.select[1]
          } else {
            this.options3 = res.data.select
          }

        })
        let checkedCities = res.data.subject_type_2.split(',').map(Number)
        this.checkedCities = checkedCities
      })
      this.$http.getareaList().then(res => {
        this.options0 = res.data.list
      })
      this.$http.getareaList({
        pid: 19
      }).then(res => {
        this.options = res.data.list
      })
      this.$http.getareaList({
        pid: this.userInfo.city
      }).then(res => {
        this.options1 = res.data.list
      })
      this.$forceUpdate()
    },
    methods: {
      getRank(e) {
        console.log(this.userInfo.score)
        if (this.userInfo.score != null && this.isRank == true && String(this.userInfo
            .score).length == 3) {
          this.$http.scoreRank({
            score: this.userInfo.score,
            year: this.userInfo.year,
            type: this.userInfo.subject_type_1
          }).then(res => {
            this.userInfo.score_rank = res.data.rank
          })
        }

      },
      out() {
        this.$store.commit('logout', true);
        localStorage.clear()
        this.$router.push({
          path: '/'
        })
      },
      kemu_change() {
        console.log(this.checkedCities)
      },
      goUrl(url) {
        this.$router.push({
          path: url
        })
      },
      save() {
        console.log(this.userInfo)
        this.userInfo.subject_mod = this.type
        if (this.userInfo.subject_type_1 == null) {
          this.userInfo.subject_type_1 = 1
        }


        this.userInfo.subject_type_2 = this.checkedCities
        this.$http.userInfo(this.userInfo).then(res => {
          if (res.code == 200) {
            this.$message.success('修改成功')

            this.$http.getUserInfo().then(res => {
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              // window.location.reload()
            })
          }
        })
      },
      changeGrade(e) {
        this.userInfo.grade = e
        this.$http.subjectTypeList({
          province_id: res.data.province,
          geade: e
        }).then(res => {
          this.type = res.data.type
          this.options3 = res.data.select
        })
      },
      change0(e) {
        if (e != 19) {
          this.$message.error('该省份暂未开放!请选择其他省份')
          return
        }
        this.userInfo.city = null
        this.userInfo.county = null
        this.userInfo.county_name = ''
        this.userInfo.city_name = ''
        this.userInfo.province = e
        // let checkedCities = res.data.subject_type_2.split(',').map(Number)
        // this.checkedCities = checkedCities
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options = res.data.list
        })
        this.$http.subjectTypeList({
          province_id: e,
        }).then(res => {
          this.type = res.data.type
          if (res.data.type == 2) {
            this.options3 = res.data.select[1]
          } else {
            this.options3 = res.data.select
          }

        })
      },
      changeYear() {
        this.$http.subjectTypeList({
          province_id: this.userInfo.province,
          year: this.userInfo.year
        }).then(res => {
          this.type = res.data.type
          if (res.data.type == 2) {
            this.options3 = res.data.select[1]
          } else {
            this.options3 = res.data.select
          }

        })
      },
      change(e) {
        this.userInfo.city = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options1 = res.data.list
        })
      },
      change1(e) {
        this.userInfo.county = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.options1 = res.data.list
        })
      },
      change2(e) {
        this.userInfo.grade = e
      },
      change3(e) {
        this.userInfo.subject_type_1 = e
        this.getRank()
      }
    }
  }
</script>

<style scoped lang="scss">
  .caozuo {
    text-align: left;

    button {
      width: 58px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #C10B17;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .caozuo1 {
    text-align: left;

    button {
      width: 128px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #C10B17;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .main1 {
    margin: 0 65px 0 65px;
    padding-bottom: 30px;

    span {
      width: 90px;
    }

    .one {
      text-align: left;
      margin: 20px 0;
      justify-content: space-between;
    }

    .one1 {
      text-align: left;
      margin: 20px 0;
      justify-content: start;

      &>view {
        display: inline-block;
      }

      span {
        display: inline-block;
        width: 90px !important;
      }

      & span:nth-chid(1) {
        display: inline-block;
        width: 90px;
      }
    }
  }

  .headImg {
    width: 70px;
    height: 70px;
    vertical-align: middle;
    border-radius: 50%;
  }

  .head1 {
    width: 100%;
    height: 54px;
    background: #FAFAFA;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 54px;
    text-align: left;
    text-indent: 25px;
  }

  .right {
    width: 893px;
    min-height: 692px;

    border: 1px solid #EDEDED;
    border-radius: 4px;
    margin-left: 24px;
  }

  .left {
    width: 283px;
    // height: 692px;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    .tixian {
      width: 70px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
    }

    .line2 {
      margin: 45px 32px 25px 32px;
      justify-content: space-between;

      span {
        color: #F9D681;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #F9D681;
      }
    }

    .line1 {
      margin-top: 27px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 11px;
      }
    }
  }

  .hello {
    width: 1300px;
    margin: 40px auto;
    align-items: flex-start;
  }

  .el-menu-vertical-demo {
    text-align: left !important;
  }
</style>
<style>
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #C10B17 !important;
    background-color: #C10B17 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #C10B17 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/me/personalCenter.vue